import { useTranslation } from 'next-i18next';
import styles from '@components/MerchandisingDisplayStatus/MerchandisingDisplayStatus.styles';
import { IPointOfPresence } from '@features/checkout/typescript';
type TPropsType = {
  store: IPointOfPresence;
  isActive?: boolean;
};
const MerchandisingDisplayStatus = ({
  store,
  isActive = false
}: TPropsType) => {
  const {
    t
  } = useTranslation('common');
  const getColorStatus = () => {
    switch (store.merchandisingDisplayStatus) {
      case 'STATUS_AVAILABLE':
        return 'green';
      case 'STATUS_LIMITED_AVAILABILITY':
        return 'yellow';
      default:
        return 'red';
    }
  };
  const getColorText = () => {
    switch (store.merchandisingDisplayStatus) {
      case 'STATUS_AVAILABLE':
        return t('available');
      case 'STATUS_LIMITED_AVAILABILITY':
        return t('limitedAvailability', {
          phoneNumber: store.contact?.phones?.[0] || ''
        });
      default:
        return t('unavailable');
    }
  };
  return <div sx={styles.container(getColorStatus(), isActive)}>
      <div> </div>
      <p className="caption">{getColorText()}</p>
    </div>;
};
export default MerchandisingDisplayStatus;